@if (!sectionRemoved()) {
  <kendo-buttongroup class="edit-section-group-control position-absolute">
    <button
      (click)="editSection()"
      kendoButton
      [toggleable]="false"
      [disabled]="sectionHidden()"
      class="edit-section icon-button k-border-none"
    >
      <fa-icon
        [ngClass]="whiteIcons() ? 'k-text-white' : 'turquoise'"
        [icon]="faEdit"
        [size]="'xs'"
        role="button"
      ></fa-icon>
    </button>
    <button
      (click)="hideSection()"
      kendoButton
      [toggleable]="false"
      class="hide-section icon-button k-border-none"
    >
      <fa-icon
        [ngClass]="whiteIcons() ? 'k-text-white' : 'turquoise'"
        [icon]="sectionHidden() ? faEyeSlash : faEye"
        [size]="'xs'"
        role="button"
      />
    </button>
    <button
      (click)="toggleSection(true)"
      kendoButton
      [toggleable]="false"
      class="remove-section icon-button k-button-solid-error-filled k-border-none"
    >
      <fa-icon
        [icon]="faTrash"
        [size]="'xs'"
        role="button"
        [ngClass]="whiteIcons() ? 'k-text-white' : 'red'"
      />
    </button>
  </kendo-buttongroup>
} @else {
  <button
    kendoButton
    themeColor="base"
    size="small"
    class="add-section icon-button k-border-none k-rounded-full k-px-1.5 k-py-1 k-aspect-ratio-1 k-mr-1"
    (click)="toggleSection(false)"
  >
    <fa-icon class="icon k-font-size-sm" [icon]="faPlus" [size]="'xs'"></fa-icon>
  </button>
}
